var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"变更记录","width":"1000","footer-hide":""},model:{value:(_vm.showProductHistory),callback:function ($$v) {_vm.showProductHistory=$$v},expression:"showProductHistory"}},[_c('Table',{attrs:{"size":"small","stripe":"","data":_vm.list,"loading":_vm.tableLoading,"columns":_vm.tableColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }